<template>
	<bsh-modal 
		:titulo="fileName"
		tamanho="modal-lg"
		:name="name">
		<template v-slot:default>
			<div class="form-row">
		    	<div class="form-group col-md-12">
	        		<img :src="imgUrl" width="100%" height="100%">
	        	</div>
	        </div>
	    </template>
    </bsh-modal>
</template>

<script>
	export default {
		props: ['file'],
		data(){
			return {
				name: 'produto_show_imagem',
				fileName: '',
				imgUrl: ''
			}
		},
  		watch: {
            file: function() {
                this.fileName = this.file.arquivo.nome;
                this.imgUrl = this.$url+'/api/adm/produto-imagens/src/'+this.file.id
            },
        }
	}
</script>